import { Rating } from "@material-tailwind/react";

export function DefaultRating() {
  return <Rating value={4} />;
}
